<template>
  <q-page padding>
    <div class="row col-12 justify-between align-center">
      <p class="text-h6 text-brand-5 text-weight-bold">Devolução de Itens</p>
    </div>
    <div class="row col-12 q-gutter-sm q-mt-sm">
      <div class="col-md-2 col-sm-12 col-xs-12 text-brand-5 text-weight-bold">
        Unidade

        <lista-unidades-select
          v-model="recebeUnidade.unidade"
        ></lista-unidades-select>
      </div>

      <div
        v-if="temPermissaoCracha()"
        class="col-md-2 col-sm-12 col-xs-12 text-brand-5 text-weight-bold"
      >
        <div class="texto-titulo-select">Crachá Solicitante</div>
        <SelecaoFuncionario
          class="input-new-design"
          dense
          outlined
          v-model="crachaSolicitante"
          @emitirFuncionario="receberFuncionarioPorCracha"
          debounce="500"
          :buscarPorCracha="true"
          :vendor-id="recebeUnidade?.id"
        />
      </div>

      <div class="col-md-2 col-sm-12 col-xs-12 text-brand-5 text-weight-bold">
        Nome do Colaborador
        <SelectComponentResponsaveis
          :vendor-id="recebeUnidade?.id"
          @emitirFuncionario="receberDadosFuncionario"
          label="Colaborador"
        />
      </div>
      <div class="q-my-md col-md-12 col-sm-12 col-xs-12">
        <div
          class="input-search-table justify-end row col-md-3 col-xs-12 col-sm-12 q-mb-md"
        >
          <q-input
            rounded
            outlined
            dense
            debounce="300"
            v-model="filter"
            type="text"
            placeholder="Filtrar"
          >
            <template v-slot:append>
              <q-icon name="search" />
            </template>
          </q-input>
        </div>
        <q-table
          class="my-sticky-dynamic"
          :hide-bottom="hideBottom"
          :rows="listaFerramentasDevolver"
          :columns="columns"
          dense
          row-key="uuid"
          :loading="loading"
          table-header-class="bg-accent text-width-bold"
          :rows-per-page-options="[0]"
          v-model:selected="selected"
          selection="single"
          flat
          :filter="filter"
          :no-data-label="semDados ? 'Item não encontrado' : ''"
        >
          <template v-slot:header="props">
            <q-tr :props="props">
              <q-th v-for="col in props.cols" :key="col.name" :props="props">
                {{ col.label }}
              </q-th>
            </q-tr>
          </template>
          <template v-slot:body="props">
            <q-tr class="text-brand-5 text-weight-bold">
              <q-td>
                <div class="row col-12 justify-center">
                  <q-btn
                    :text-color="props.selected ? 'black' : ''"
                    :color="props.selected ? 'accent' : 'primary'"
                    no-caps
                    round
                    dense
                    @click="
                      (props.selected = !props.selected),
                        receberDadosFerramenta(props.row)
                    "
                    :icon="
                      props.selected
                        ? 'check_circle_outline'
                        : 'add_circle_outline'
                    "
                  />
                </div>
              </q-td>
              <q-td>
                <span>{{ props.row.nome }}</span>
              </q-td>
              <q-td>
                <span>{{ props.row.descricao }}</span>
              </q-td>
              <q-td>
                <span>{{ props.row.patrimonio }}</span>
              </q-td>
              <q-td>
                <span>{{ props.row.unidadeId }}</span>
              </q-td>
              <q-td>
                <span>{{ props.row.responsavelNome }}</span>
              </q-td>
              <q-td>
                <div>
                  <span class="row col-12">
                    {{
                      props.row.dataRetirada
                        .split(" ")[0]
                        .split("-")
                        .reverse()
                        .join("/")
                    }}
                  </span>
                </div>
              </q-td>
            </q-tr>
          </template>
        </q-table>
      </div>
    </div>
    <div class="row col-12 col-sm-12 col-xs-12 justify-start">
      <p
        v-if="checklists.length > 0"
        class="text-h6 text-brand-5 q-mb-md text-weight-bold"
      >
        Verificação de Integridade
      </p>
      <ul v-if="checklists.length > 0" class="col-12" style="list-style: none">
        <li
          class="text-brand-5"
          v-for="checklist in checklists"
          :key="checklist.descricao"
        >
          {{ checklist.descricao }}
          <div class="row col-12">
            <q-radio
              v-model="checklist.resposta"
              :val="true"
              label="Sim"
            ></q-radio>
            <q-radio
              v-model="checklist.resposta"
              :val="false"
              label="Não"
            ></q-radio>
          </div>
        </li>
      </ul>
      <div
        v-if="listaFerramentasDevolver.length > 0"
        class="row col-12 q-my-lg"
      >
        <p class="text-h6 text-brand-5 q-mb-md text-weight-bold">
          Tipo Autenticação
        </p>
        <div class="row col-12 q-ml-md container-autenticacao q-mb-lg">
          <q-radio
            v-if="!$store.state.autenticacao.cliente.includes('acciona')"
            v-model="filtro.tipoAutenticacao"
            label="Sem Autenticação"
            val="sem_autenticacao"
            size="lg"
          />
          <q-radio
            v-model="filtro.tipoAutenticacao"
            label="Biometria"
            val="biometria"
            size="lg"
          />
          <q-radio
            v-model="filtro.tipoAutenticacao"
            label="Assinatura"
            val="assinatura"
            size="lg"
          />
          <q-radio
            v-model="filtro.tipoAutenticacao"
            label="PIN"
            val="web_pin"
            size="lg"
          />
        </div>
        <div class="q-ml-lg" v-if="filtro.tipoAutenticacao === 'biometria'">
          <div v-if="filtro.biometry">
            <q-img
              v-if="usuarioVerificado"
              class="imagem-biometria"
              src="../../../assets/bioOK.png"
              @click="biometria = !biometria"
            />
            <q-img
              v-else
              class="imagem-biometria"
              src="../../../assets/bioRequest.png"
              @click="biometria = !biometria"
            />
            <span
              class="q-ml-sm text-bold text-brand-5"
              style="font-size: 16px"
            >
              <span v-if="!usuarioVerificado">
                Clique no icone da digital para fazer o reconhecimento da
                biometria.
              </span>
              <span v-else>
                Biometria Verificada, clique em Finalizar para devolver o item.
              </span>
            </span>
            <BiometriaModal
              :modal="biometria"
              :userId="filtro.responsavelId"
              :titulo="'Verificação de Biometria'"
              :tipoBiometria="'verificacao'"
              @negativePrint="recebeBiometria"
              @resultadoVerificacao="receberResultadoBiometria"
            />
          </div>
        </div>
        <div class="row col-12" v-if="filtro.tipoAutenticacao === 'assinatura'">
          <Canvas
            v-if="!assinaturaColetada"
            @update="receberAssinatura"
            :go="salvarAssinatura"
          />
          <span
            class="q-ml-sm text-bold text-positive"
            style="font-size: 21px"
            v-else
          >
            <span class="text-positive"> Assinatura coletada. </span>
          </span>
        </div>
        <div
          class="row col-12 items-center q-ml-md"
          v-if="filtro.tipoAutenticacao == 'web_pin'"
        >
          <div class="row col-12" v-if="!pinColetado">
            <q-icon class="q-mr-sm" name="lock" size="37px" />
            <q-input type="password" dense outlined v-model="pin" />
          </div>
          <span
            class="q-ml-sm text-bold text-positive"
            style="font-size: 21px"
            v-else
          >
            <span class="text-positive"> PIN coletado. </span>
          </span>
        </div>
      </div>
      <div class="row col-12 items-end q-gutter-sm">
        <div class="col-md-8 col-sm-10 col-xs-12">
          <div>
            <p class="text-brand-5 text-weight-bold">Observações:</p>
            <q-input
              class="col-9 col-xs-12 col-sm-12"
              v-model="filtro.observacoes"
              type="textarea"
              outlined
            />
          </div>
        </div>
        <div class="col-lg-2 col-md-2 col-xs-12 col-sm-12 q-mt-md">
          <q-btn
            class="full-width"
            color="positive"
            label="Finalizar"
            type="submit"
            icon="done"
            no-caps
            :disable="desabilitado"
            @click="verificarTipoAutenticacao()"
          />
        </div>
      </div>
    </div>
  </q-page>
</template>

<script>
import { ref, watch, onMounted } from "vue";
import { useStore } from "vuex";
import { useQuasar } from "quasar";
import SelectComponentResponsaveis from "../components/SelectComponentResponsaveis.vue";
import SelecaoFuncionario from "../../ferramentaria/components/SelecaoFuncionario.vue";

import BiometriaModal from "../../biometria/views/Biometria.vue";
import ListaUnidadesSelect from "../../organizacional/unidade/component/ListaUnidadesSelect.vue";
import Canvas from "../components/Canvas.vue";

export default {
  name: "RetirarFerramentas",
  components: {
    SelectComponentResponsaveis,
    SelecaoFuncionario,
    BiometriaModal,
    ListaUnidadesSelect,
    Canvas,
  },
  setup() {
    const store = useStore();
    const $q = useQuasar();
    const checklists = ref([]);
    const filtroChecklist = ref([]);
    let arrayFerramentas = [];
    let estado = ref(true);
    let semDados = ref(false);
    let disable = ref(false);
    let loading = ref(false);
    let hideBottom = ref(true);
    const ferramentas = ref([]);
    let recebeUnidade = ref({
      unidade: store.state.org.unidadeData.nome,
      id: store.state.org.unidadeData.id,
    });
    const listaFerramentasDevolver = ref([]);
    const filtro = ref({
      unidadeId: "",
      uuid: "",
      movimentacao_uuid: "",
      nome: "",
      descricao: "",
      responsavelId: "",
      responsavelNome: "",
      permanencia: "",
      dataPrevista: "",
      dataRetirada: "",
      dataEntrega: "",
      resposta: "",
      observacoes: "",
      tipoAutenticacao: "",
    });

    const crachaSolicitante = ref(null);
    const usuarioEncontradoPorCracha = ref(null);

    const columns = [
      {
        name: "ferramentasselecionadas",
        label: "Selecione",
        field: "",
        align: "left",
      },
      {
        name: "codigo",
        label: "Código",
        field: "nome",
        align: "left",
        sortable: true,
      },
      {
        name: "descricao",
        label: "Descrição",
        field: "descricao",
        align: "left",
        sortable: true,
      },
      {
        name: "patrimonio",
        label: "Patrimonio",
        field: "patrimonio",
        align: "left",
        sortable: true,
      },
      {
        name: "unidade",
        label: "Unidade",
        field: "unidadeId",
        align: "left",
        sortable: true,
      },
      {
        name: "responsavelNome",
        label: "Colaborador",
        field: "responsavelNome",
        align: "left",
      },
      {
        name: "dataRetirada",
        label: "Data da Retirada",
        field: (row) => formataDataHora(row.dataRetirada),
        align: "left",
      },
    ];
    const filter = ref("");
    let biometria = ref(false);
    let usuarioVerificado = ref(false);
    const imagemBase64 = ref(null);
    const pin = ref("");
    const selected = ref([]);
    let desabilitado = ref(false);
    const salvarAssinatura = ref(0);
    const assinaturaColetada = ref(false);
    const pinColetado = ref(false);

    const formataDataHora = (dataHora) => {
      const data = dataHora.split(" ")[0].split("-").reverse().join("/");

      const hora = dataHora.split(" ")[1].replace(".000000", "");

      return `${data} ${hora}`;
    };

    let listarFerramentasDevolver = async () => {
      loading.value = true;
      if (filtro.value.responsavelId) {
        let resposta = await store.dispatch("fer/listarFerramentasDevolver", {
          responsavelId: filtro.value.responsavelId,
          unidade: recebeUnidade.value.id,
        });
        loading.value = false;

        listaFerramentasDevolver.value = resposta.listaFerramentasDevolver;
        hideBottom.value = true;

        if (listaFerramentasDevolver.value == "") {
          loading.value = false;
          hideBottom.value = false;
          semDados.value = true;
          return;
        }
        return;
      }
      loading.value = false;
      $q.notify({
        message:
          "Por favor, digite o nome do colaborador que devolverá o item!",
        color: "negative",
        actions: [
          {
            label: "Fechar",
            color: "white",
            handler: () => {
              /* ... */
            },
          },
        ],
      });
    };

    let receberDadosFuncionario = async (value) => {
      filtro.value.responsavelId = value.id;
      filtro.value.responsavelNome = value.nome;
      filtro.value.biometry = value.biometry;
    };

    let receberDadosFerramenta = async (row) => {
      checklists.value = [];
      if (selected.value.length > 0) {
        arrayFerramentas.push(row.uuid);
        filtro.value.nome = row.nome;
        filtro.value.uuid = row.uuid;
        filtro.value.movimentacao_uuid = row.movimentacao_uuid;

        estado.value = false;
        disable.value = true;
        row.checklist.forEach((e) => {
          checklists.value.push({
            uuid: `${e.uuid}`,
            descricao: `${e.descricao}`,
            resposta: undefined,
          });
        });
      }
    };

    const receberFuncionarioPorCracha = (value) => {
      if (value === "") {
        return;
      }
      filtro.value.responsavelId = value.id;
      filtro.value.responsavelNome = value.nome;
      filtro.value.biometry = value.biometry;
    };

    const buscarPorCracha = async (card_id) => {
      if (!card_id || card_id.trim() === "") {
        usuarioEncontradoPorCracha.value = null;
        return;
      }

      try {
        const response = await store.dispatch("fer/listarFuncionarios", {
          card_id: card_id,
          vendor_id: recebeUnidade.value?.id,
        });

        if (response.data?.results?.data?.length > 0) {
          const usuario = response.data.results.data[0];
          usuarioEncontradoPorCracha.value = usuario;

          const funcionarioFormatado = {
            id: usuario.sap,
            idTabela: usuario.id,
            nome: usuario.name,
            matricula: usuario.sap,
            centroCustoCode: usuario.cost_center?.code,
            centroCustoName: usuario.cost_center?.name,
            biometria: usuario.biometry,
          };

          receberFuncionarioPorCracha(funcionarioFormatado);
        } else {
          usuarioEncontradoPorCracha.value = null;
        }
      } catch (error) {
        console.error("Erro ao buscar usuário por crachá:", error);
        usuarioEncontradoPorCracha.value = null;
      }
    };

    const temPermissaoCracha = () => {
      return (
        store.state.autenticacao?.usuarioLogado?.permissoes?.gmapi?.roles?.includes(
          "voucher-auth-cracha"
        ) || false
      );
    };

    let enviaDadosFerramenta = async () => {
      ferramentas.value = [];
      filtroChecklist.value = [];

      checklists.value.forEach((value) => {
        filtroChecklist.value.push({
          uuid: value.uuid,
          descricao: value.descricao,
          resposta: value.resposta,
        });
      });

      ferramentas.value.push({
        uuid: selected.value[0].uuid,
        observacoes: filtro.value.observacoes,
        check_lists: filtroChecklist.value,
      });
    };

    let devolverFerramentas = async () => {
      if (selected.value.length == 0) {
        $q.notify({
          message: "Selecione ao menos um item pra fazer a devolução.",
          color: "negative",
          actions: [
            {
              label: "fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        return;
      }
      if (filtro.value.tipoAutenticacao === "") {
        if (filtro.value.tipoAutenticacao === "") {
          $q.notify({
            message: "Escolha um método de autenticação.",
            color: "negative",
            actions: [
              {
                label: "fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
          return;
        }
        return;
      }
      if (
        (imagemBase64.value == null &&
          filtro.value.tipoAutenticacao == "biometria") ||
        (imagemBase64.value == null &&
          filtro.value.tipoAutenticacao == "asinatura")
      ) {
        $q.notify({
          message: "Realize a autenticação para a fazer a devolução dos itens.",
          color: "negative",
          actions: [
            {
              label: "fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        return;
      }
      if (
        !usuarioVerificado.value &&
        filtro.value.tipoAutenticacao === "biometria"
      ) {
        $q.notify({
          message: "A Biometria coletada não coincide com a do requisitante",
          color: "negative",
          actions: [
            {
              label: "fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        return;
      }
      enviaDadosFerramenta();
      checklists.value.forEach((value) => {
        if (value.resposta == undefined) {
          $q.notify({
            message: "Responda todos os checklists",
            color: "negative",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
        }
      });
      try {
        $q.notify({
          message: "Processando devolução.",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        desabilitado.value = true;
        await store.dispatch("fer/devolverFerramenta", {
          responsavelId: filtro.value.responsavelId,
          movimentacao_uuid: filtro.value.movimentacao_uuid,
          dh_devolucao: gerarTimestamp(),
          ferramentas: ferramentas.value,
          biometria: imagemBase64.value,
        });
        if (filtro.value.tipoAutenticacao === "assinatura") {
          assinaturaColetada.value = true;
        }
        if (filtro.value.tipoAutenticacao === "web_pin") {
          pinColetado.value = true;
        }
        $q.notify({
          message: "O item foi devolvido com sucesso!",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });

        listarFerramentasDevolver();
        selected.value = [];
        ferramentas.value = "";
        filtro.value.observacoes = "";
        disable.value = false;
        checklists.value = [];
        desabilitado.value = false;
      } catch (e) {
        desabilitado.value = false;
        if (e.request.status < 500) {
          for (let index in e.response.data.errors) {
            $q.notify({
              message: e.response.data.errors[index],
              color: "negative",
              actions: [
                {
                  label: "Fechar",
                  color: "white",
                  handler: () => {
                    /* ... */
                  },
                },
              ],
            });
          }
        }
        if (e.request.status >= 500) {
          $q.notify({
            message: "Erro no servidor, tente novamente",
            color: "negative",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
        }
      }
    };

    const recebeBiometria = async (value) => {
      imagemBase64.value = value;
    };

    const checarPin = async () => {
      if (pin.value == "") {
        $q.notify({
          message: "O campo não pode estar vazio",
          color: "negative",
          actions: [
            {
              label: "fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        return;
      }
      try {
        const response = await store.dispatch("requisicao/checarPin", {
          pin: pin.value,
          user_id: filtro.value.responsavelId,
        });
        if (response.data.result.pin_correto) {
          $q.notify({
            message: "Senha Validada com Sucesso.",
            color: "positive",
            actions: [
              {
                label: "fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
          usuarioVerificado.value = true;
          imagemBase64.value = null;
          devolverFerramentas();
        } else {
          $q.notify({
            message: "PIN digitado, não corresponde ao pin do usuário!",
            color: "negative",
            actions: [
              {
                label: "fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
        }
      } catch (error) {
        $q.notify({
          message: "Erro ao validar pin",
          color: "negative",
          actions: [
            {
              label: "fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const receberResultadoBiometria = (value) => {
      usuarioVerificado.value = value;
    };

    const receberAssinatura = async (value) => {
      if (value == undefined || value == null) {
        $q.notify({
          message: "Assine para finalizar a retirada.",
          color: "negative",
          actions: [
            {
              label: "fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        return;
      }
      imagemBase64.value = value.split("base64,")[1];
      devolverFerramentas();
    };

    const verificarTipoAutenticacao = () => {
      if (filtro.value.tipoAutenticacao == "web_pin") {
        if (pinColetado.value) {
          devolverFerramentas();
          return;
        }
        checarPin();
        return;
      }
      if (filtro.value.tipoAutenticacao == "assinatura") {
        if (assinaturaColetada.value) {
          devolverFerramentas();
          return;
        }
        salvarAssinatura.value++;
        return;
      }
      if (filtro.value.tipoAutenticacao == "biometria") {
        devolverFerramentas();
        return;
      }
      devolverFerramentas();
    };

    const gerarTimestamp = () => {
      let dataAtual = new Date();

      let ano = dataAtual.getFullYear();
      let mes = (dataAtual.getMonth() + 1).toString().padStart(2, "0");
      let dia = dataAtual.getDate().toString().padStart(2, "0");
      let horas = dataAtual.getHours().toString().padStart(2, "0");
      let minutos = dataAtual.getMinutes().toString().padStart(2, "0");
      let segundos = dataAtual.getSeconds().toString().padStart(2, "0");

      return `${ano}-${mes}-${dia} ${horas}:${minutos}:${segundos}`;
    };

    watch(
      () => store.state.org.unidadeData.id,
      () => {
        if (store.state.org.unidadeData == null) {
          return;
        }
        recebeUnidade.value.unidade = store.state.org.unidadeData;
        recebeUnidade.value.id = store.state.org.unidadeData.id;
        listarFerramentasDevolver();
      }
    );

    const getUnidade = () => {
      if (
        localStorage.unidade &&
        localStorage.unidade != null &&
        localStorage.unidade != "null"
      ) {
        let getunidade = localStorage.getItem("unidade");
        recebeUnidade.value.unidade = JSON.parse(getunidade);
      }
    };

    onMounted(getUnidade);

    const resetar = () => {
      usuarioVerificado.value = false;
      imagemBase64.value = null;
      pin.value = "";
      ferramentas.value = [];
      checklists.value = [];
      selected.value = [];
      filtro.value.tipoAutenticacao = "";
      assinaturaColetada.value = false;
    };

    watch(
      () => filtro.value.responsavelId,
      () => {
        resetar();
        listarFerramentasDevolver();
      }
    );

    watch(
      () => filtro.value.tipoAutenticacao,
      () => {
        usuarioVerificado.value = false;
        imagemBase64.value = null;
        pin.value = "";
        assinaturaColetada.value = false;
        pinColetado.value = false;
      }
    );

    return {
      filtro,
      selecionaFuncionario: ref(false),
      receberDadosFuncionario,
      receberFuncionarioPorCracha,
      buscarPorCracha,
      temPermissaoCracha,
      crachaSolicitante,
      usuarioEncontradoPorCracha,
      columns,
      listarFerramentasDevolver,
      listaFerramentasDevolver,
      receberDadosFerramenta,
      enviaDadosFerramenta,
      devolverFerramentas,
      checklists,
      ferramentas,
      filtroChecklist,
      disable,
      estado,
      loading,
      semDados,
      hideBottom,
      recebeUnidade,
      filter,
      biometria,
      usuarioVerificado,
      receberResultadoBiometria,
      checarPin,
      recebeBiometria,
      pin,
      imagemBase64,
      resetar,
      selected,
      desabilitado,
      receberAssinatura,
      salvarAssinatura,
      assinaturaColetada,
      verificarTipoAutenticacao,
      pinColetado,
      gerarTimestamp,
    };
  },
};
</script>

<style scoped>
.q-table__top,
thead tr:first-child th {
  background-color: #eef3fe;
}

thead tr th {
  position: sticky;
  z-index: 1;
}
thead tr:first-child th {
  top: 0;
}

.q-table--loading thead tr:last-child th {
  top: 48px;
}
.my-sticky-dynamic {
  max-height: 400px;
}
thead tr th {
  position: sticky;
  z-index: 1;
}
thead tr:last-child th {
  top: 48px;
}
thead tr:first-child th {
  top: 0;
}
.elipse {
  width: 12px;
  height: 12px;
  border-radius: 50%;
}
tbody tr td {
  white-space: pre-wrap;
}
.imagem-biometria {
  height: 80px;
  width: 80px;
  cursor: pointer;
}
</style>
